const tr = {
  // Navigation
  nav_home: "Ev",
  nav_explore: "Keşfetmek",
  nav_workspace: "Çalışma alanı",
  ws_videos: "videolar",
  ws_untitled: "Başlıksız video",
  // A generation that failed. The card carries these until it is dismissed.
  ws_failed_title: "Video başarısız oldu",
  ws_failed_refunded: "Krediniz iade edildi",
  ws_failed_dismiss: "Azletmek",
  ws_failed_retry: "Tekrar deneyin",
  ws_failed_retrying: "Başlangıç…",
  ws_failed_banner_one: "Video oluşturulamadı",
  ws_failed_banner_many: "{n} video başarısız oldu",
  ws_failed_banner_body: "Hiçbir ücret alınmadı; kredi hesabınıza geri döndü. Tekrar deneyin veya farklı bir konu seçin.",
  ws_empty_title: "Burada henüz bir şey yok.",
  ws_empty_body: "Yaptığınız her video, en yenisi önce gelecek şekilde burada görünecektir.",
  ws_generate: "Oluştur",
  ws_composer_placeholder: "Bir dersi açıklayın\u2026",
  ws_placeholder_hw: "Ödeve bir ad verin… (isteğe bağlı)",
  ws_placeholder_lecture: "Derse isim verin… (isteğe bağlı)",
  ws_placeholder_self_study: "Ne okumak istiyorsun?",
  nav_search: "Videoları ara...",
  nav_search_yours: "Videolarınızı arayın...",
  nav_notifications: "Bildirimler",
  nav_mark_all_read: "Tümünü okundu olarak işaretle",
  nav_no_notifications: "Henüz bildirim yok",
  nav_no_notifications_sub: "Videolarınız hazır olduğunda sizi bilgilendireceğiz",
  nav_upgrade: "Güncelleme",
  nav_billing: "Faturalandırma",
  nav_settings: "Ayarlar",
  nav_contact: "Bize Ulaşın",
  nav_api: "API'si",
  nav_sign_out: "oturumu Kapat",
  nav_just_now: "Şu anda",
  nav_minutes_ago: "{n}m önce",
  nav_hours_ago: "{n}sa önce",
  nav_days_ago: "{n} gün önce",
  nav_used_this_month: "Bu ay {used} / {cap} kullanıldı",
  // locale file, and this one is the obvious thing to reach for if a weekly bucket returns.
  nav_used_today: "Bu hafta {used} sayıdan {limit} kullanıldı",
  nav_free_daily: "Haftada 4 ücretsiz video",
  // Settings
  settings_title: "Ayarlar",
  settings_profile: "Profil",
  settings_change_avatar: "Avatarı değiştir",
  settings_cancel: "İptal etmek",
  settings_choose_wizard: "Sihirbazınızı seçin",
  settings_display_name: "Ekran adı",
  settings_your_name: "Adınız",
  settings_save: "Kaydetmek",
  settings_saving: "Kaydediliyor...",
  settings_saved: "Kaydedildi",
  settings_save_failed: "Kaydedilemedi",
  settings_email: "E-posta",
  settings_notifications: "Bildirimler",
  settings_email_notif: "E-posta bildirimleri",
  settings_email_notif_desc: "Güncellemeleri ve duyuruları e-posta yoluyla alın",
  settings_language: "Dil",
  settings_language_desc: "Uygulama ve video anlatımı için dili seçin",
  settings_data_title: "Verileriniz",
  settings_data_desc: "Profiliniz, videolarınız, kurslarınız, oturumlarınız ve destek mesajlarınız dahil olmak üzere hesabınızla ilişkili kişisel verilerin bir kopyasını indirin. Dahili sistem günlükleri ve türetilmiş işleme verileri dahil değildir.",
  settings_data_download: "Verilerimi indir",
  settings_data_exporting: "Hazırlanıyor…",
  settings_danger: "Tehlikeli Bölge",
  settings_delete_account: "Hesabı Sil",
  settings_delete_desc: "Hesabınızı ve ilişkili tüm verileri kalıcı olarak silin. Bu eylem geri alınamaz.",
  settings_delete_confirm: "Bu, hesabınızı ve tüm verilerinizi kalıcı olarak silecektir. Onaylamak için {keyword} yazın.",
  settings_delete_placeholder: "Onaylamak için \"SİL\" yazın",
  settings_permanently_delete: "Kalıcı Olarak Sil",
  settings_deleting: "Siliniyor...",
  explore_watch_now: "Şimdi İzle",
  // One pair of strings per scene; the eyebrow and the button are shared.
  explore_no_preview: "Önizleme yok",
  explore_no_videos: "Henüz video mevcut değil. Yakında tekrar kontrol edin!",
  explore_featured_courses: "Öne Çıkan Kurslar",
  course_lesson_count: "{n, plural, one {# lesson} other {# lessons}}",
  course_back_to_explore: "Keşfet'e Geri Dön",
  course_not_found: "Bu kurs mevcut değil.",
  // Home Page
  home_hero: "Her şeyi öğren,",
  home_hero_accent: "görsel olarak",
  home_placeholder: "Neyi öğrenmek veya çözmek istiyorsunuz?",
  home_extracting: "Sorular çıkarılıyor...",
  home_videos_generated: "{n, plural, one {# video} other {# video}} oluşturulacak",
  home_credits: "{n, plural, one {# kredi} other {# kredi}}",
  home_remaining: "bu ay kalan",
  home_enter_prompt: "Lütfen öğrenmek veya çözmek istediğiniz konuyu giriniz",
  home_popular: "Popüler Dersler",
  home_from_community: "Topluluktan",
  home_community_sub: "Öğrencilerin neler yarattığını görün",
  home_tips_label: "Magi sihirbazından",
  home_tips_title: "İpuçları ve Püf Noktaları",
  home_tip1_title: "Spesifik olun",
  home_tip1_desc: "Konunun tamamını yazmayın. Bir fikir, bir kavram, bir soru seçin.",
  home_tip1_example: "Ökaryotik hücrelerde DNA replikasyonu nasıl çalışır?",
  home_tip2_title: "Kimin için olduğunu söyle",
  home_tip2_desc: "Ortaokul açıklaması, üniversite dersinden tamamen farklı görünüyor.",
  home_tip2_example: "Cebiri yeni öğrenmiş biri için türevleri açıklayın",
  home_tip3_title: "Magi'ye ne istediğini söyle",
  home_tip3_desc: "Örnekler, adım adım gerçek dünya uygulamaları — sadece söyleyin ve Magi sizi takip etsin.",
  home_tip3_example: "Gerçek dünyadan örnekler ve bir özet ile su döngüsü",
  home_tip_try: "Şöyle bir şey dene",
  home_proven_social: "Bizi Instagram'da takip edin",
  home_ig_desc_1: "Üzerinde",
  home_ig_followers: "55.000 takipçi",
  home_ig_desc_2: "Her gün Instagram'daki matematik ve fen videolarımızı izleyin. Bu makaralar burada kullandığınız motorla yapılmıştır.",
  home_view_profile: "Profili görüntüle",
  home_subscribe_now: "Şimdi abone olun",
  home_sub_monthly: "Aylık",
  home_sub_yearly: "Yıllık",
  // goes false the moment either price moves, on the surface where that matters most.
  home_sub_yearly_save: "%{pct} tasarruf edin",
  home_sub_per_month: "/ ay",
  home_sub_billed_monthly: "her ay ${amount} tutarında faturalandırılır",
  home_sub_processing: "İşleme...",
  home_sub_no_commitment: "Taahhüt yok. İstediğiniz zaman iptal edin.",
  home_sub_secured: "Stripe tarafından güvence altına alınmıştır",
  home_sub_headline: "{plan} ile daha fazlasının kilidini açın",
  home_sub_due_now: "Vadesi şimdi",
  home_sub_trial_label: "{days} günlük tam erişim",
  // choosing the plan directly is owed exactly what a trialist is owed.
  home_sub_monthly_terms: "Bu ayki ${amount} video için bugün sizden {n} tutarında ödeme alınacak. Siz önce iptal etmediğiniz sürece, {date} tarihinde ${amount}/ay tutarında yenilenir; istediğiniz zaman Faturalandırma bölümünden iptal edin.",
  // frequency, states that it happens automatically, and says where to cancel.
  home_sub_trial_terms: "${trial} günlük tam erişim için bugün sizden {days} tutarında ödeme alınacak ve bu ücret {n} videoyla sınırlıdır. Deneme süresi ${trial} tarihinde devam etmeyecek; {date} tarihinde otomatik olarak aylık {planName} (${plan} videolar) tutarında {full} olur ve siz iptal edene kadar bundan sonra her ay ${plan} tutarında ücret alınır. Faturalandırma'dan istediğiniz zaman iptal edin.",
  home_sub_card: "Kredi veya Banka Kartı",
  home_sub_billed_once_yearly: "yılda bir kez ${amount} faturalandırılır",
  home_sub_billed_trial: "${amount} gün boyunca {days} tutarında faturalandırılır, ardından her ay ${renews} tutarında yenilenir",
  home_sub_switch_plan: "Bunun yerine {plan} mı arıyorsunuz?",
  home_sub_replaces_plan: "{plan} planınızın yerine geçer. Faturalama tarihiniz aynı kalır; yukarıya doğru hareket etmek farkı şimdi etkiler, aşağı doğru hareket bir sonraki yenilemenizde başlar.",
  home_sub_change_now: "Artık {plan} planındasınız — fark için {amount} tahsil edildi.",
  home_sub_change_later: "{date} tarihinde {plan} planına geçeceksiniz. Bugün ücret alınmadı.",
  // the allowance changed; this one cannot.
  home_sub_feature_videos_n: "Ayda {n} video",
  // Pricing Page
  pricing_title: "Planınızı yükseltin",
  pricing_monthly: "Aylık",
  pricing_yearly: "Yıllık",
  pricing_save: "%17 tasarruf edin",
  pricing_best_value: "En İyi Değer",
  pricing_your_plan: "Mevcut planınız",
  pricing_get_started: "Başlayın",
  pricing_processing: "İşleme...",
  pricing_per_month: "/ay",
  pricing_billed_yearly: "${amount}/yıl faturalandırıldı",
  pricing_videos_month: "{n, plural, one {# video} other {# video}}/ay",
  pricing_manage_cancel: "Yönet veya iptal et",
  pricing_manage_unavailable: "Yönetilecek bir abonelik bulamadık. Lütfen bize ulaşın, halledelim.",
  pricing_opening: "Açılıyor...",
  billing_autorenew_monthly: "Siz iptal edene kadar aylık ${amount} tutarında otomatik olarak yenilenir.",
  billing_autorenew_yearly: "Siz iptal edene kadar yıllık ${amount} tutarında otomatik olarak yenilenir.",
  billing_autorenews_on: "{date} otomatik olarak yenilenir · istediğiniz zaman iptal edin",
  pricing_secured: "Stripe tarafından güvence altına alınmıştır",
  pricing_login_required: "Abone olmak için lütfen giriş yapın",
  pricing_auth_error: "Kullanıcı kimlik doğrulama hatası. Lütfen çıkış yapıp tekrar giriş yapmayı deneyin.",
  pricing_feature_pdf: "PDF ve görüntü çıkarma",
  pricing_feature_quality: "Daha kaliteli model",
  pricing_feature_speed: "Daha hızlı nesil süresi",
  pricing_feature_study: "Çalışma oturumları",
  pricing_free_hint: "Şu anda Ücretsiz planda",
  // Billing Page
  billing_title: "Faturalandırma",
  billing_current_plan: "Mevcut Plan",
  billing_payment_failed_title: "Planınız duraklatıldı",
  billing_payment_failed_body: "{amount} miktarını tahsil edemediğimiz için planınız duraklatıldı. Tekrar başlatmak için kartınızı güncelleyin; biz de yeniden denemeye devam edeceğiz.",
  billing_payment_failed_cta: "Ödemeyi düzelt",
  billing_change_plan: "Planı değiştir",
  billing_invoices: "Faturalar",
  billing_loading: "Faturalar yükleniyor...",
  billing_no_invoices: "Henüz fatura yok",
  billing_date: "Tarih",
  billing_amount: "Miktar",
  billing_status: "Durum",
  billing_invoice: "Fatura",
  billing_view: "Görüş",
  // Contact Page
  contact_title: "Bize Ulaşın",
  contact_placeholder: "Nasıl yardımcı olabiliriz?",
  contact_sent_desc: "En kısa sürede size geri döneceğiz.",
  contact_signin: "Destek ekibiyle iletişime geçmek için lütfen oturum açın.",
  // Generation Queue
  queue_title: "Sıra",
  queue_active: "{n} aktif",
  queue_generating: "{n} üretiyor",
  queue_ready: "İzlemeye hazır",
  queue_in_queue: "Sırada bekliyor...",
  queue_almost_ready: "Neredeyse hazır...",
  queue_seconds_left: "{n} kaldı",
  queue_minutes_left: "{m}m {s} kaldı",
  queue_watch_now: "Şimdi izle",
  queue_waiting: "Sırada beklemek...",
  queue_empty: "Sırada video yok",
  queue_empty_sub: "Burada görmek için bir video oluşturun",
  queue_clear: "Tümünü temizle",
  queue_total: "{n} toplam",
  queue_first_time: "Videonuz oluşturuluyor",
  queue_first_time_sub: "Genellikle ~2 dk. Hazır olduğunda bir zil sesi duyacaksınız.",
  // Session Expired
  session_expired: "Oturumun Süresi Doldu",
  session_expired_desc: "Oturumunuzun süresi güvenlik nedeniyle sona erdi. Devam etmek için lütfen tekrar oturum açın.",
  // Cookie Banner
  cookie_text: "Site trafiğini analiz etmek ve deneyiminizi geliştirmek için çerezleri kullanıyoruz. Varsayılan olarak yalnızca gerekli çerezler ayarlanmıştır.",
  cookie_learn_more: "Daha fazla bilgi edin",
  cookie_accept: "Tümünü kabul et",
  cookie_reject: "Gerekli olmayanları reddet",
  // Create Project Modal
  create_new_project: "Yeni Proje",
  create_extracting: "Çıkarılıyor...",
  create_select_problems: "Sorunları Seçin",
  create_select_topics: "Konuları Seçin",
  create_new_video: "Yeni Video",
  create_new_hw: "Yeni Ödev Projesi",
  create_new_lecture: "Yeni Ders Projesi",
  create_new_self_study: "Yeni Proje",
  create_video: "Video",
  create_homework: "Ev ödevi",
  create_lecture: "Ders",
  create_self_study: "Proje",
  create_video_sub: "Video oluştur",
  create_hw_sub: "Ödev yükle",
  create_lecture_sub: "Slaytları yükle",
  create_self_study_sub: "Konularınızı seçin",
  create_video_prompt: "Video neyi açıklamalı?",
  create_project_title: "Proje başlığı",
  create_video_hint: "Bu, videonuzun hem başlığı hem de istemi olarak kullanılacaktır.",
  create_drop_hw: "Ödevinizi buraya bırakın",
  create_drop_lecture: "Ders slaytlarınızı buraya bırakın",
  create_file_types: "PDF, PNG, JPG, HEIC",
  // Shown over the composer while a file is being dragged onto it.
  composer_drop_hint: "Bir projeye başlamak için bırakın",
  create_reading_hw: "Ödevini okumak",
  create_reading_lecture: "Dersinizi okumak",
  create_finding_problems: "Sorunları bulma ve çıkarma...",
  create_finding_topics: "Konular çıkarılıyor...",
  create_add_video: "Başka bir video ekle",
  create_add_more_files: "Daha fazla dosya ekle",
  create_starting: "Nesil başlıyor...",
  create_generate_video: "Video Oluştur \u00B7 1 kredi",
  create_generate_n: "{n, plural, one {# Video} other {# Video}} Oluştur \u00B7 {n, plural, one {# kredi} other {# kredi}}",
  create_create_project: "Proje oluştur \u00B7 {n, plural, one {# kredi} other {# kredi}}",
  create_no_problems: "Herhangi bir sorun bulunamadı. Daha net bir fotoğraf veya farklı bir sayfa deneyin.",
  create_no_topics: "Herhangi bir konu bulunamadı. Daha net bir fotoğraf veya farklı bir dosya deneyin.",
  create_error: "Bir şeyler ters gitti. Lütfen tekrar deneyin.",
  create_extract_daily_limit: "Bugünlük belgeler bu kadar. Daha fazlası yarın.",
  create_video_topic_placeholder: "Video {n} konusu, ör. \"Özdeğerler ve Özvektörler\"",
  video_share: "Paylaşmak",
  // and made the two indistinguishable.
  video_followup_placeholder: "Takip videosu oluşturun...",
  video_chip_simpler: "Daha basit açıklayın",
  video_chip_harder: "Daha zor örnek",
  video_chip_real_world: "Gerçek dünya kullanımı",
  // spends a credit generating a new one.
  video_ask_title: "Bu video hakkında soru sorun",
  video_ask_cta: "Bunun hakkında sohbet et",
  video_ask_placeholder: "Bir soru sorun...",
  video_ask_thinking: "Düşünüyorum...",
  video_ask_close: "Kapalı",
  video_ask_chip_explain: "O kısmı açıkla",
  video_ask_chip_example: "Bir örnek ver",
  video_ask_chip_why: "Bu neden işe yarıyor?",
  video_ask_limit_reached: "Bugünün soru sınırına ulaştınız. Yarın sıfırlanır.",
  video_up_next: "Sonraki",
  video_no_suggested: "Henüz önerilen video yok",
  video_untitled: "Başlıksız Video",
  video_created_recently: "Yakın zamanda oluşturuldu",
  video_just_now: "Şu anda",
  video_minutes_ago: "{n, plural, one {# dakika} other {# dakika}} önce",
  video_hours_ago: "{n, plural, one {# saat} other {# saat}} önce",
  video_days_ago: "{n, plural, one {# gün} other {# gün}} önce",
  video_weeks_ago: "{n, plural, one {# hafta} other {# hafta}} önce",
  video_months_ago: "{n, plural, one {# ay} other {# ay}} önce",
  video_years_ago: "{n, plural, one {# yıl} other {# yıl}} önce",
  video_unknown_date: "Bilinmeyen tarih",
  video_download_error: "Bir şeyler ters gitti. Lütfen tekrar deneyin.",
  // Search Results
  search_no_results: "Sonuç bulunamadı",
  search_no_results_for: "\"{query}\" için sonuç bulunamadı",
  search_all_videos: "Tüm videoları ara",
  search_enter_term: "Videoları bulmak için bir arama terimi girin",
  search_retry: "Aramayı Yeniden Dene",
  auth_continue_google: "Google ile devam et",
  // sentence, and the box ships unticked — a pre-ticked box is not consent.
  home_sub_waiver: "Erişimimi hemen başlat. Bunun, {days} günlük para çekme ve geri ödeme alma hakkımdan vazgeçtiğim anlamına geldiğini anlıyorum.",
  home_sub_waiver_required: "Devam etmek için lütfen bunu onaylayın.",
  home_sub_agree_prefix: "Devam ederek şunları kabul etmiş olursunuz:",
  // floor is 13 — if that clause changes, this string and DIGITAL_CONSENT_AGE move with it.
  auth_min_age: "Magi'yi kullanabilmek için {age} veya daha büyük olmanız gerekir.",
  auth_agree_prefix: "Oturum açarak şunları kabul etmiş olursunuz:",
  auth_terms: "Hizmet Şartları",
  auth_and: "Ve",
  auth_privacy: "Gizlilik Politikası",
  auth_email_optin: "Bana ipuçları ve güncellemeler gönder",
  // Auth modal (Google + email/password)
  auth_signin_title: "Magi'de oturum açın",
  auth_signin_desc: "Kaldığınız yerden devam edin.",
  auth_signup_title: "Hesabınızı oluşturun",
  auth_signup_desc: "Başlamak ücretsiz, karta gerek yok.",
  auth_or: "veya",
  auth_continue_email: "E-postayla devam et",
  auth_signing_in: "Oturum açılıyor…",
  auth_working: "Bir saniye…",
  auth_email_placeholder: "E-posta adresi",
  auth_password_placeholder: "Şifre",
  auth_signin_submit: "Oturum aç",
  auth_signup_submit: "Hesap oluşturmak",
  auth_no_account: "Burada yeni misin?",
  auth_signup_link: "Bir hesap oluşturun",
  auth_have_account: "Zaten bir hesabınız var mı?",
  auth_signin_link: "Oturum aç",
  auth_forgot_password: "Şifrenizi mi unuttunuz?",
  auth_reset_title: "Şifrenizi sıfırlayın",
  auth_reset_desc: "Yeni bir tane ayarlamanız için size e-postayla bir bağlantı göndereceğiz.",
  auth_reset_submit: "Sıfırlama bağlantısını gönder",
  auth_reset_sent: "Sıfırlama bağlantısı için e-postanızı kontrol edin.",
  auth_back_to_signin: "Oturum açmak için geri dön",
  // Full-screen wall shown to a signed-in account that has not confirmed its address.
  verify_wall_title: "Devam etmek için e-postanızı onaylayın",
  verify_wall_desc: "{email} adresine bir onay bağlantısı gönderdik. Tıklayın ve buraya geri dönün.",
  verify_wall_check: "Onayladım",
  verify_wall_checking: "Kontrol ediliyor...",
  verify_wall_still_unverified: "Henüz onaylanmadı. E-postadaki bağlantıya tıklayın ve tekrar deneyin.",
  verify_wall_resend: "Bağlantıyı tekrar gönder",
  verify_wall_resent: "Gönderilmiş. Gelen kutunuzu ve spam klasörünüzü kontrol edin.",
  verify_wall_wrong_account: "Yanlış hesap mı? oturumu Kapat",
  // The screen the confirmation LINK lands on, replacing Firebase's unbranded handler page.
  verify_action_working_title: "E-postanız onaylanıyor",
  verify_action_working_desc: "Bir dakika.",
  verify_action_done_title: "Artık hazırsınız",
  verify_action_done_desc: "E-postanız onaylandı. Magi'ye hoş geldiniz.",
  verify_action_done_cta: "Öğrenmeye başla",
  verify_action_failed_title: "Bu bağlantı işe yaramadı",
  verify_action_failed_desc: "Zaten kullanılmış olabilir veya süresi dolmuş olabilir. Geri dönün ve kendinize yeni bir tane gönderin.",
  verify_action_failed_cta: "Magi'ye geri dön",
  // Wall copy — each surface names what signing in actually gets you
  auth_watch_title: "İzlemek için oturum açın",
  auth_watch_desc: "Bu videoyu oynatmak için ücretsiz bir hesap oluşturun.",
  auth_watch_ready_title: "Videonuz hazır",
  auth_watch_ready_desc: "İzlemek için oturum açın; hesabınıza kaydedilecektir.",
  // rather than saying "sign in" twice — the specific ask converts, the generic one nags.
  auth_download_title: "İndirmek için oturum açın",
  auth_download_desc: "Bu videoyu kaydetmek için ücretsiz bir hesap oluşturun.",
  auth_ask_title: "Sormak için oturum açın",
  auth_ask_desc: "Bu video hakkında soru sormak için ücretsiz bir hesap oluşturun.",
  auth_browse_title: "Göz atmak için oturum açın",
  auth_browse_desc: "Her dersi keşfetmek için ücretsiz bir hesap oluşturun.",
  auth_workspace_title: "Çalışmanızı görmek için oturum açın",
  auth_workspace_desc: "Dersleriniz ve projeleriniz hesabınızda yaşıyor.",
  auth_generate_title: "Oluşturmaya devam etmek için oturum açın",
  auth_generate_desc: "Ücretsiz hesaplara her gün bir video gelir.",
  video_restricted: "Bu video henüz kullanılamıyor.",
  // Share sheet
  share_title: "Bu videoyu paylaş",
  share_desc_mobile: "Hikayenize gönderin, bir arkadaşınıza gönderin veya bağlantıyı kopyalayın.",
  share_desc_desktop: "Bağlantıyı kopyalayın veya telefonunuzdan yayınlamak için videoyu indirin.",
  share_to_apps: "Instagram'da ve daha fazlasında paylaşın",
  share_copy_link: "Bağlantıyı kopyala",
  share_copied: "Bağlantı kopyalandı",
  share_download: "Videoyu indir",
  share_preparing: "Hazırlanıyor…",
  share_watermark_note: "Paylaşılan videolar arasında magiacademy.com bulunmaktadır",
  // Welcome Modal (post-signup)
  welcome_title: "Magi'ye hoş geldiniz",
  welcome_subtitle: "Başlamak için 4 ücretsiz videonuz var.",
  welcome_optin_reward: "+1 ücretsiz video",
  welcome_continue: "Devam etmek",
  age_gate_continue: "Devam etmek",
  age_gate_saving: "Kaydediliyor...",
  // Landing Page
  landing_hero: "Bir konu yazın.",
  landing_hero2: "Videolu ders alın.",
  landing_subtitle: "Magi, her konuyu dakikalar içinde güzelce canlandırılan, anlatılan bir videoya dönüştürür. Filme gerek yok, düzenleme yok, uzmanlığa gerek yok.",
  landing_signup_google: "Google'a kaydolun",
  landing_signing_in: "Oturum açılıyor...",
  landing_chat_bubble: "GPS göreliliği nasıl kullanır?",
  landing_stats_title: "Dünyanın her yerindeki öğrencilerin güvendiği",
  landing_stat_videos: "3.000+",
  landing_stat_videos_desc: "Oluşturulan videolar",
  landing_stat_languages_desc: "Diller",
  landing_stat_speed: "~1 dakika",
  landing_stat_speed_desc: "Nesil zamanı",
  landing_feature_lecture_title: "Ders notlarınızı bırakın, videolar alın",
  landing_feature_lecture_desc: "Slaytlarınızı veya notlarınızı yükleyin. Magi her konuyu ortaya çıkarıyor ve her biri için bir video açıklaması oluşturuyor.",
  landing_feature_hw_title: "Ev ödevine mi takıldın? Yükle.",
  landing_feature_hw_desc: "Bir problem seti bırakın ve Magi her problemi çıkarsın, ardından adım adım bir videoyla çözüm boyunca size yol göstersin.",
  landing_feature_chat_title: "İzlerken soru sorun",
  landing_feature_chat_desc: "Her video, sohbet edebileceğiniz bir AI öğretmeniyle birlikte gelir. Devam soruları sorun, daha derin açıklamalar alın veya daha iyi anlamak istediğiniz belirli bir bölümle ilgili yeni bir video isteyin.",
  landing_feature_lang_title: "Kendi dilinizde öğrenin",
  landing_feature_lang_desc: "Magi İngilizce, İspanyolca, Hintçe, Çince, Japonca ve daha birçok dilde videolar oluşturur. Konunuzu herhangi bir dilde yazın ve o dilde tamamen anlatımlı bir ders alın.",
  landing_cta_title: "Saniyeler içinde öğrenmeye başlayın",
  landing_cta_google: "Google ile devam et",
  // Onboarding Bubbles
  onboarding_step1: "Bu bir sohbet robotu değil \u2014 bir konu yazın, sizin için tam bir video dersi hazırlayacağım!",
  onboarding_step2: "Veya bir PDF veya fotoğraf bırakın \u2014 Her sorunu adım adım video çözümüne dönüştüreceğim",
  onboarding_step3: "Devam et tuşuna bastığınızda videonuz sıraya katılır. Oluşturulurken göz atmaya devam edebilirsiniz!",
  onboarding_generating: "Bu, birkaç dakika süren dersinizin çekilişidir. İsterseniz göz atmaya devam edin; hazır olduğunda tam buraya inecek.",
  onboarding_skip: "Atlamak",
  onboarding_next: "Sonraki",
  onboarding_done: "Anladım!",
  // Generating Cards Row
  generating_label: "Üretiliyor",
  // Lecture Session (Self Study)
  lecture_loading: "Yükleniyor...",
  lecture_fallback_title: "Ders",
  lecture_building: "Yapım videosu...",
  lecture_building_time: "Bu genellikle 2-4 dakika sürer",
  lecture_failed: "Video oluşturma başarısız oldu",
  lecture_no_video: "Henüz video yok",
  lecture_followup: "Takip etmek",
  lecture_now_playing: "Şimdi oynatılıyor",
  lecture_tab_videos: "Videolar",
  lecture_tab_chat: "Sohbet",
  lecture_chat_empty: "Bu konu hakkında bir şey sorun",
  lecture_chat_chip1: "Basitçe açıklayın",
  lecture_chat_chip2: "Bir örnek ver",
  lecture_chat_chip3: "Bu neden faydalıdır?",
  lecture_chat_placeholder: "Bu konuyu sorun...",
  lecture_followup_placeholder: "Bir devam videosu ekleyin...",
  lecture_chat_error: "Üzgünüm, bunu işleyemedim. Tekrar deneyin.",
  lecture_chat_generic_error: "Bir şeyler ters gitti. Tekrar deneyin.",
  // Home shortcuts — square cards that jump to the Workspace composer preset to a mode
  home_sc_hw_title: "Ödev PDF'si",
  home_sc_hw_desc: "Bir problem seti yükleyin, her soru için çalışılmış bir video alın",
  home_sc_lecture_title: "Ders PDF'si",
  home_sc_lecture_desc: "Slaytları veya notları bir dizi derse dönüştürün",
  home_sc_course_title: "Kurs oluştur",
  home_sc_course_desc: "Bir konu üzerinde bir dizi ders planlayın",
  // Misc
  generic_error: "Bir şeyler ters gitti. Lütfen tekrar deneyin.",
  loading: "Yükleniyor...",
};

export default tr;
